<div class="variables-result">
  @if (hasSourceVariables()) {
    <div class="variables-result__toolbar">
      <ui-search
        [placeholder]="'VARIABLES.PLACEHOLDERS.SEARCH' | translate"
        [searchQuery]="searchQuery()"
        (onInput)="onSearchQuery($event)"
      ></ui-search>
      <ui-button
        type="secondary"
        [text]="'VARIABLES.BUTTONS.CREATE' | translate"
        (clickAction)="createVariable()"
      ></ui-button>
    </div>
  }

  @if (variables().length) {
    @if (tableConfig(); as config) {
      <div class="table-wrapper">
        <ui-dataset-table [data]="variables()" [config]="config" (rowAction)="onRowAction($event)"></ui-dataset-table>
      </div>
    }
  } @else {
    <ui-no-data
      [imgSrc]="hasSourceVariables() ? noResults.imgSrc : noData.imgSrc"
      [title]="(hasSourceVariables() ? noResults.title : noData.title) | translate"
      [createButtonText]="!hasSourceVariables() ? (noData.createButtonText | translate) : undefined"
      (onCreate)="createVariable()"
    ></ui-no-data>
  }

  <ng-template #typeCell let-row><div class="type-chip">{{ formatVariableType(row.type) }}</div></ng-template>
  <ng-template #valueCell let-row>
    <div class="flex-row start-center">
      @if (isJsonVariable(row)) {
        <ui-button iconClass="ui-icon-eye" type="default" (clickAction)="viewJson(row.value)"></ui-button>
      } @else {
        <div class="value-chip">{{ row.value }}</div>
      }
    </div>
  </ng-template>
</div>
